import { ReferenceDataConstants } from './../../../lib/constants/reference-data-constants';
import { ReferenceDataOptionLists } from './../../../lib/constants/reference-data-option-lists';
import { ApplicationCase } from './../../../lib/models/api/application-case.model';
import { Fee } from './../../../lib/models/api/fee.model';

export abstract class FormApplication {
  public ApplicationCase: ApplicationCase;
  public Fee: Fee;
  public IsFullApp: boolean;
  public IsAip: boolean;
  public IsKfi: boolean;
  public IsApplicationReadOnly: boolean;
  public IsFactFindReadOnly: boolean;
  public IsFactFind: boolean;

  public isPurchase: boolean;
  public isRemortgage: boolean;
  public isBuyToLet: boolean;
  public isResidential: boolean;
  public isAdvisedCase: boolean;
  public isScottishProperty: boolean;
  public isBrokerApplication: boolean;
  public isBranchApplication: boolean;

  public RepaymentTypeCodeCache: string;
  public LoanAmountCache?: number;
  public PropertyEPCRatingCode: string;
  public EPCRating: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.Fee = input.Fee ? new Fee().deserialize(input.Fee) : new Fee();
    if (this.ApplicationCase) {
      this.ApplicationCase = new ApplicationCase().deserialize(input.ApplicationCase);
      this.isPurchase =
        this.ApplicationCase.PurchaseOrRemortgageCode === ReferenceDataOptionLists.PurchaseOrRemortgagePurchase;
      this.isRemortgage =
        this.ApplicationCase.PurchaseOrRemortgageCode === ReferenceDataOptionLists.PurchaseOrRemortgageRemortgage;
      this.isBuyToLet = this.ApplicationCase.LoanGroupTypeCode === ReferenceDataOptionLists.LoanGroupTypeBuyToLet;
      this.isResidential = this.ApplicationCase.LoanGroupTypeCode === ReferenceDataOptionLists.LoanGroupTypeResidential;
      this.isScottishProperty =
        this.ApplicationCase.PropertyLocationCode === ReferenceDataOptionLists.PropertyLocationScotland;
      this.isBrokerApplication =
        this.ApplicationCase.InterfaceTypeIDCache === ReferenceDataConstants.BROKER_INTERFACE_TYPE_ID;
      this.isBranchApplication =
        this.ApplicationCase.InterfaceTypeIDCache === ReferenceDataConstants.BRANCH_INTERFACE_TYPE_ID;
      this.isAdvisedCase = this.ApplicationCase.CaseType === ReferenceDataOptionLists.CaseTypeAdvisedOption;
    }

    return this;
  }
}
